import React from "react";
import { Dialog, Slide, Backdrop, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddStoreDocumntationForm from "layouts/store_documntation/components/newStore_documntation";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const AddStoreDocumntaionModal = ({ open, onClose, onUserAdded, initialData }) => {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={onClose}
      fullWidth
      maxWidth="xl"
      BackdropComponent={Backdrop}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0,0,0,0.5)",
          backdropFilter: "blur(4px)",
        },
      }}
      PaperProps={{
        style: {
          marginTop: "5vh",
          borderRadius: "16px",
          overflow: "auto", // ✅
          maxHeight: "100vh", // ✅
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 16,
          top: 16,
          color: "text.main",
          zIndex: 1,
        }}
      >
        <CloseIcon />
      </IconButton>

      <AddStoreDocumntationForm
        initialData={initialData} // Pass initial data
        onClose={onClose}
        onSuccess={() => {
          onClose();
          onUserAdded();
        }}
      />
    </Dialog>
  );
};

export default AddStoreDocumntaionModal;
